import { usePlayer } from 'src/context';

import useMetaData from '../hooks/video-player/useMetaData';
import eventTracker from './eventTracker';

const helper = {
  isUserloggedIn: () => {
    let userLoggedIn = false;
    if (typeof window !== 'undefined') {
      const userDetail = window.sessionStorage.getItem('isAuthenticated');
      if (userDetail) {
        userLoggedIn = JSON.parse(userDetail);
      }
    }
    return userLoggedIn;
  },

  userInfodata: () => {
    let userInfo;
    if (typeof window !== 'undefined') {
      userInfo = JSON.parse(localStorage?.getItem('user') || '{}');
    }

    return userInfo;
  },
};

export const videoPlayerFeatureHelper = (featureName: string) => {
  const { isFullScreen } = usePlayer();
  const { scheduleDetails } = useMetaData();
  const data = {
    class_type: scheduleDetails?.videoDetails && scheduleDetails?.isLive ? 'live' : 'recorded',
    screen_type: !isFullScreen ? 'full' : 'semi_full',
    feature_name: featureName,
    video_id: scheduleDetails?.videoDetails?._id,
    schedule_id: scheduleDetails._id,
    UserPhoneNumber: helper.userInfodata().primaryNumber,
  };

  eventTracker.videoPlayerFeature(data);
};

export default helper;
